import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import {BrandKitPaletteEditor} from '@Components/auto-branding/components/brand-kit-palette-editor/brand-kit-palette-editor';
import {PALETTE_APPLIED_EVENT} from '@/types/email-maker-global.constants';
import {RightPanelOverlayHeader} from '../../components/right-panel-overlay-header/right-panel-overlay-header';
import type {BrandKitSuggestionsViewProps} from './brand-kit-suggestions-view.types';
import styles from './brand-kit-suggestions-view.module.scss';

export function BrandKitSuggestionsView({target, onSuggestedPaletteSelect, onBack}: BrandKitSuggestionsViewProps): ReactElement {
  return (
    <div className={styles.view}>
      <RightPanelOverlayHeader title={window.i18next.t('pmwjs_styles')} backAriaLabel={window.i18next.t('pmwjs_back')} onBack={onBack} />
      <div className={styles.panel}>
        <Text val={window.i18next.t('pmwjs_brand_kit_palette_auto_generation')} size={TextSize.SM} />
        <BrandKitPaletteEditor
          brandKitPalette={target.brandKitPalette}
          suggestedPalettes={target.suggestedPalettes}
          colorPaletteAppliedEvent={PALETTE_APPLIED_EVENT}
          onPaletteSelect={onSuggestedPaletteSelect}
          onBrandKitUpdate={onBack}
        />
      </div>
    </div>
  );
}
